import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {NgxSpinnerService} from 'ngx-spinner';

import {EMPTY, firstValueFrom, of} from 'rxjs';
import {filter, first, takeUntil} from 'rxjs/operators';

import {BaseFormComponent, FormManagerService} from '@sim/form';

import {CardsApiService, SwalService} from '@atmi/core';

import {checkUniqueCodeDuplicate} from '@atmi/core/validators';
import {CardS, CardSMeta} from '@atmi/models/cards/card-s';

export interface CardDialogData {
  cardS: CardS;
}

@Component({
  selector: 'app-card-s-form-dialog',
  styleUrls: ['./card-s-form-dialog.component.scss'],
  templateUrl: './card-s-form-dialog.component.html',
})
export class CardSFormDialogComponent extends BaseFormComponent<CardS> {

  readonly title = this.translate.instant('Crea scheda figlia di ') + (this.data.cardS.SGT.SGTT || this.data.cardS.SGT.SGTT || '');

  readonly mainActionLabel = this.translate.instant('Crea');

  constructor(
    private readonly dialogRef: MatDialogRef<CardSFormDialogComponent>,
    private readonly swalService: SwalService,
    private readonly cardsApi: CardsApiService,
    protected readonly formManager: FormManagerService,
    protected readonly translate: TranslateService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly spinner: NgxSpinnerService,
    protected readonly cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public readonly data: CardDialogData,
  ) {

    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      cd,
      CardSMeta,
      () => of(data.cardS),
    );

    this.onFormInit$.pipe(
      filter((form): form is UntypedFormGroup => !!form),
      takeUntil(this.onDestroy$),
    ).subscribe((form) => {
      form.controls.codiceUnico.setAsyncValidators([checkUniqueCodeDuplicate(this.cardsApi.indexS.bind(this.cardsApi), 0)]);
      form.controls.codiceUnico.updateValueAndValidity();
    });
  }

  addConcrete() {
    return EMPTY;
  }

  removeConcrete() {
    return EMPTY;
  }

  editConcrete() {
    return EMPTY;
  }

  resetFormConcrete() {
    return this.entityForm.reset();
  }

  async completeHandler() {
    if (this.entityForm.valid) {
      // Merge form value with benePadre from initial data to ensure it's included in the POST request
      const cardData = {
        ...this.entityForm.value,
        benePadre: this.data.cardS.benePadre
      };
      
      const childCard = await firstValueFrom(this.cardsApi.postS(cardData, 's').pipe(first()));

      const confirmResult = await this.swalService.showConfirm({
        text: this.translate.instant('Vuoi andare alla pagina di dettaglio della scheda appena creata?'),
        title: this.translate.instant('Creazione avvenuta con successo'),
      });

      if (confirmResult) {
        this.router.navigate(['/cards/s/manager', childCard.id]);
        this.dialogRef.close();
      } else {
        this.dialogRef.close(this.entityForm.value);
      }
    } else {
      this.entityForm.markAllAsTouched();
    }
  }

}
